/**
* @prop --uic-header-menu-bg-color: default background color
* @prop --uic-header-menu-bg-color-secondary: background color for variant `secondary`
* @prop --uic-header-menu-text-color: default text and icon color
*/
uic-header-menu {
    display: block;
    position: relative;
    background-color: var(--uic-header-menu-bg-color);
    color: var(--uic-header-menu-text-color);

    .uic-header-menu__inner {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
    }
}

.uic-header-menu {
    &--secondary {
        background-color: var(--uic-header-menu-bg-color-secondary);
    }
}

.uic-header-menu {
    &--vertical {
        .uic-header-menu__inner {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
        }

        uic-header-menu-item {
            justify-content: flex-start;
        }
    }
}
